import { render, staticRenderFns } from "./PurchasesTableRow.vue?vue&type=template&id=06ed4075&lang=pug&"
import script from "./PurchasesTableRow.vue?vue&type=script&lang=js&"
export * from "./PurchasesTableRow.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesTableRow.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
